import safeLocalStorage from 'safe-localstorage';
import { mapStyles } from 'src/services/constants';
import Bounds from 'src/models/Bounds';

/** @typedef {'DEFAULT' | 'LIGHT' | 'DARK' | 'SATELLITE' } MapStyle */

export default () => {
  let vehicleMapStyle = safeLocalStorage.get('map/mapStyle');
  if (vehicleMapStyle) {
    // TODO: remove this later after most have migrated the local storage data to the key
    // Check if map style is referencing a map style path or key
    const isKey = Object.keys(mapStyles).some((key) => key === vehicleMapStyle);
    if (!isKey) {
      // Saved value is the path (old way), change the value to use a key
      vehicleMapStyle = Object.keys(mapStyles).find((key) => mapStyles[key] === vehicleMapStyle);
      safeLocalStorage.set('map/mapStyle', vehicleMapStyle);
    }
  }

  /**
   * Handle old local storage references
   */
  // TODO: remove this later after most have migrated the local storage data
  const clusterVehicles = safeLocalStorage.get('map/clusterVehicles');
  if (clusterVehicles) {
    safeLocalStorage.set('map/clusterAssets', clusterVehicles);
    safeLocalStorage.remove('map/clusterVehicles');
  }

  return {
    assetRecentMapStyle: safeLocalStorage.get('map/assetRecentMapStyle') || 'LIGHT',
    contextualMenuOpen: false,
    clusterableAssetsGeoJson: null,
    clusteredBounds: {},
    clusterAssets: safeLocalStorage.get('map/clusterAssets') !== 'false', // enabled by default
    displayExternalAddress: false,
    fittingTo: new Bounds(),
    idealBounds: new Bounds(),
    inViewportFencesHash: null,
    legendOpened: safeLocalStorage.get('map/legendOpened') !== 'false', // open by default
    listDialogOpen: false,
    liveMapInitialized: false,
    lockToIdealBounds: false,
    /** @type {MapStyle} */
    mapStyle: vehicleMapStyle || 'LIGHT',
    matchesIdealBounds: false,
    /** @type {MapStyle} */
    nearbyMapStyle: safeLocalStorage.get('map/nearbyMapStyle') || 'LIGHT',
    nearbyVehiclesFiltered: true,
    pendingFitToIdeal: false,
    publishBoundsThrottleDelay: 500,
    reservingOnLoadFocus: null,
    selectedAssetGeoJson: null,
    selectedDrawerShouldUpdate: false,
    showAddPlace: false,
    showExternalAddress: false,
    showDriverNameInList: safeLocalStorage.get('map/showDriverNameInList') === 'true',
    showAddressInList: safeLocalStorage.get('map/showAddressInList') === 'true',
    showNicknameInList: safeLocalStorage.get('map/showNicknameInList') !== 'false', // enabled by default
    showTagColors: safeLocalStorage.get('map/showTagColors') === 'true',
    showPlaces: safeLocalStorage.get('map/showPlaces') !== 'false', // enabled by default
    showTraffic: safeLocalStorage.get('map/showTraffic') === 'true',
    tripsMapShowPlaces: safeLocalStorage.get('map/tripsMapShowPlaces') !== 'false', // enabled by default
    tripsMapStyle: safeLocalStorage.get('map/tripsMapStyle') || 'LIGHT',
    zoomLevel: 0,
  };
};
